<script>

import Layout from "../../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { useConstantStore } from '@/store/constantStore'

import { ref } from "vue";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
                const constantStore = useConstantStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          constantStore
        };
    },
    page: {
    title: "constantes",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "constantes",
      items: [
        {
          text: "Définition",
        },
        {
          text: "constantes",
          active: true,
        },
      ],
      errors: [],
      constante: {},
      constantes: [],
      name: "",
      value: "",
      description: "",
      label: "",
      option: "",  
      group: "",
      boolean: true,
      label_en: "",
      label_fr: "",
      label_ru: "",
      label_pt: "",
      description_en: "",
      description_fr: "",
      description_ru: "",
      description_pt: "",
      length: 0,

      loading: false,
      status: 201,
    };
  },
  methods: {

        
  async loadFromStore() {

      if (!this.constantStore.list) {
       await  this.constantStore.loadFromApi(true).then(data => {
        this.constantes = data
        this.constant_search = data;
        this.length = this.constantes.length;
    })
      } else {
        this.constantes = this.constantStore.list
        this.constant_search = this.constants;
                this.length = this.constantes.length;

      }

  },

 async refresh(){
   await  this.constantStore.loadFromApi(true).then(data => {
        this.constantes = data
        this.constant_search = data;
        this.length = this.constantes.length;
    })
 },


  

    addItem() {
      this.errors = [];
     let body = {
        name: this.name,
        label: this.label,
        value: this.value,
        option: this.option,  
        group: this.group,
        status: this.boolean,
        label_en: this.label_en,
        label_fr: this.label_fr,
        label_ru: this.label_ru,
        label_pt: this.label_pt,
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
        description_pt: this.description_pt,
      }
      this.constantStore.createItem(body);
      this.constants = this.constantStore.list
      this.constant_search = this.constants

    },

    editItem() {
      this.errors = [];
       let body = {
        name: this.name,
        label: this.label,
        value: this.value,
        option: this.option,  
        group: this.group,
        status: this.boolean,
        label_en: this.label_en,
        label_fr: this.label_fr,
        label_ru: this.label_ru,
        label_pt: this.label_pt,
        description_en: this.description_en,
        description_fr: this.description_fr,
        description_ru: this.description_ru,
        description_pt: this.description_pt,
      }

      this.constantStore.editItem(this.constante.id, body);
      this.constants = this.constantStore.list
      this.constant_search = this.constants

     
    },

     deleteIt() {
       this.constantStore.deleteItem(this.constante.id);
      this.constants = this.constantStore.list
      this.constant_search = this.constants
    },

  







    initItem(constante, action="edit") {
      this.constante = constante
      this.initData(constante)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        this.doesEditOpen = true
      }
    },
    initData(item = null) {
      this.name = item != null ? item.name : "";
      this.label = item != null ? item.label : "";
      this.option = item != null ? item.option : "";
      this.value = item != null ? item.value : "";
      this.boolean = item != null ? item.status : "";
      this.group = item != null ? item.group : "";
      this.label_en = item != null ? item.label_en : "";
      this.label_fr = item != null ? item.label_fr : "";
      this.label_ru = item != null ? item.label_ru : "";
      this.label_pt = item != null ? item.label_pt : "";
      this.description_en = item != null ? item.description_en : "";
      this.description_fr = item != null ? item.description_fr : "";
      this.description_ru = item != null ? item.description_ru : "";
      this.description_pt = item != null ? item.description_pt : "";
    }
  },
  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.constante = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.constante = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    

    <div class="hstack mb-3">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
        <b-button variant="primary" @click="doesAddOpen = true" class="ms-1">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des constantes</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <value>constantes</value>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>constante</th>
                    <th>Label</th>
                    <th>value</th>
                    <th>description</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(constante, i) in constantes" :key="constante.id">
                    <th scope="row">{{ i + 1 }}</th>
                    <td>{{ constante.label }}</td>
                    <td>{{ constante.name }}</td>
                    <td>{{ constante.value }}</td>
                    <td>{{ constante.description_fr }}</td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(constante, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(constante, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="lg"
        title="Ajouter un constante"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="">Nom du constante</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label</label>
              <input type="text" required v-model="label" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label">{{ errors.label }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Valeur</label>
              <input type="text" required v-model="value" class="form-control">
              <span class="text-danger mt-2" v-if="errors.value">{{ errors.value }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Groupe</label>
              <input type="text" required v-model="group" class="form-control">
              <span class="text-danger mt-2" v-if="errors.group">{{ errors.group }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Option</label>
              <input type="text" required v-model="option" class="form-control">
              <span class="text-danger mt-2" v-if="errors.option">{{ errors.option }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Status</label>
              <select required v-model="status" class="form-control">
                <option value="" selected>Statut</option>
                <option :value="true">Activé</option>
                <option :value="false">Desactivé</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label FR</label>
              <input type="text" required v-model="label_fr" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_fr">{{ errors.label_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label EN</label>
              <input type="text" required v-model="label_en" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_en">{{ errors.label_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label PT</label>
              <input type="text" required v-model="label_pt" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_pt">{{ errors.label_pt }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label RU</label>
              <input type="text" required v-model="label_ru" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_ru">{{ errors.label_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea required v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea required v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea required v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea required v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="lg"
        title="Modifier un constante"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="">Nom du constante</label>
              <input type="text" required v-model="name" class="form-control">
              <span class="text-danger mt-2" v-if="errors.name">{{ errors.name }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label</label>
              <input type="text" required v-model="label" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label">{{ errors.label }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Valeur</label>
              <input type="text" required v-model="value" class="form-control">
              <span class="text-danger mt-2" v-if="errors.value">{{ errors.value }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Groupe</label>
              <input type="text" required v-model="group" class="form-control">
              <span class="text-danger mt-2" v-if="errors.group">{{ errors.group }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Option</label>
              <input type="text" required v-model="option" class="form-control">
              <span class="text-danger mt-2" v-if="errors.option">{{ errors.option }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Status</label>
              <select required v-model="boolean" class="form-control">
                <option :value="true">Activé</option>
                <option :value="false">Desactivé</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label FR</label>
              <input type="text" required v-model="label_fr" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_fr">{{ errors.label_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label EN</label>
              <input type="text" required v-model="label_en" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_en">{{ errors.label_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label PT</label>
              <input type="text" required v-model="label_pt" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_pt">{{ errors.label_pt }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Label RU</label>
              <input type="text" required v-model="label_ru" class="form-control">
              <span class="text-danger mt-2" v-if="errors.label_ru">{{ errors.label_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description FR</label>
              <textarea required v-model="description_fr" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_fr">{{ errors.description_fr }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description EN</label>
              <textarea required v-model="description_en" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_en">{{ errors.description_en }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description RU</label>
              <textarea required v-model="description_ru" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_ru">{{ errors.description_ru }}</span>
            </div>
            <div class="col-md-6 mb-3">
              <label for="">Description PT</label>
              <textarea required v-model="description_pt" class="form-control"></textarea>
              <span class="text-danger mt-2" v-if="errors.description_pt">{{ errors.description_pt }}</span>
            </div>
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un constante"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer le constante <b>{{ constante?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
